import { render } from "./Input.vue?vue&type=template&id=870a0d6c&scoped=true"
import script from "./Input.vue?vue&type=script&lang=js"
export * from "./Input.vue?vue&type=script&lang=js"

import "./Input.vue?vue&type=style&index=0&id=870a0d6c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-870a0d6c"]])

export default __exports__